import React, { Provider } from 'react-redux';
import store from '../ReduxImpl/store/index';
import JssFormDisplay from './jssStatefullform';

const PrivacyForm = ({ fields, history }) => {
  return (
    <Provider store={store}>
      <JssFormDisplay fields={fields} history={history} />
    </Provider>
  );
};

export default PrivacyForm;
